import React from "react";
import { Link } from "react-router-dom";

// Section container with consistent padding
export const Section = ({ children, className = "", id, dark = false, stone = false }) => {
  const bg = dark ? "bg-navy text-white" : stone ? "bg-stone text-navy" : "bg-white text-navy";
  return (
    <section id={id} className={`${bg} ${className}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-28">{children}</div>
    </section>
  );
};

export const Kicker = ({ children, className = "", light = false }) => (
  <p
    className={`text-xs tracking-kicker uppercase mb-4 ${
      light ? "text-steel-light" : "text-steel"
    } ${className}`}
  >
    {children}
  </p>
);

export const Heading = ({ children, className = "", as: Tag = "h2" }) => (
  <Tag className={`tracking-heading font-semibold leading-[1.1] ${className}`}>{children}</Tag>
);

// Buttons ---------------------------------------------------------------
const base =
  "inline-flex items-center justify-center gap-2 text-sm font-medium tracking-wide transition-all duration-200 px-7 py-3.5";

const variants = {
  primary: "bg-navy text-white hover:bg-navy-700",
  primaryLight: "bg-white text-navy hover:bg-stone",
  outline: "border border-navy/25 text-navy hover:border-navy hover:bg-navy hover:text-white",
  outlineLight: "border border-white/30 text-white hover:bg-white hover:text-navy",
};

export const Button = ({ children, to, href, variant = "primary", className = "", testid, ...rest }) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testid} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testid} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button className={cls} data-testid={testid} {...rest}>
      {children}
    </button>
  );
};

// Thin steel divider rule
export const Rule = ({ className = "" }) => (
  <span className={`block h-px w-16 bg-steel/50 ${className}`} />
);
